// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap--8qL68zq clearfix","list":"list-1pSy0_0j"};